import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import { useAppKit, useAppKitAccount } from '@reown/appkit/react';
import { createAppKit } from '@reown/appkit/react'
import { EthersAdapter } from '@reown/appkit-adapter-ethers'
import { bsc } from '@reown/appkit/networks'
import axios from 'axios';
import AdminPanel from './components/AdminPanel';

function GiftCheck() {
  const { address } = useAppKitAccount();
  const [giftStatus, setGiftStatus] = useState(null);
  const [showAnimation, setShowAnimation] = useState(false);
  const { open } = useAppKit();

  const checkWallet = async (walletAddress) => {
    try {
      const api = `https://uns-gift-574634440075.europe-west4.run.app/get/${walletAddress}`;
      const { data } = await axios.get(api);
      return { success: true, data };
    } catch (error) {
      if (error.response?.status === 404) {
        return { success: false, data: null };
      }
      console.error('Error checking wallet:', error);
      return { success: false, data: null };
    }
  };

  const handleCheck = async () => {
    if (!address) {
      open();
      return;
    }
    
    const result = await checkWallet(address);
    if (result.success) {
      setShowAnimation(true);
      setGiftStatus(result.data);
    } else {
      setShowAnimation(false);
      setGiftStatus(false); // This will trigger the error message
    }
  };

  const formatUnlockDate = (timestamp) => {
    if (!timestamp) return 'TBA';
    return new Date(timestamp * 1000).toLocaleDateString();
  };

  return (
    <div className="App">
      <div className="gift-container">
        <div className="logo-container">
          <img 
            src="https://i.ibb.co/QXhF0QK/UNS-Word.png"
            alt="UNS Logo"
            className="uns-logo"
          />
        </div>
        {!address ? (
          <div className="check-form">
            <h2>Check Your Gift</h2>
            <button onClick={handleCheck}>Connect Wallet</button>
          </div>
        ) : giftStatus === null ? (
          <div className="check-form">
            <h2>Wallet Connected</h2>
            <p className="wallet-address">{address}</p>
            <button onClick={handleCheck}>Check Gift</button>
          </div>
        ) : giftStatus ? (
          <div className={`success-message ${showAnimation ? 'gift-pop' : ''}`}>
            <div className="gift-icon">🎁</div>
            <h2>🎉 Congratulations! 🎉</h2>
            <p className="gift-amount">You have {giftStatus.num * 1000} UNS gift!</p>
            <p className="unlock-date">
              Gift unlocks on: {formatUnlockDate(giftStatus.unlocks_at)}
            </p>
            <button className="claim-button" disabled>
              Claim Gift
            </button>
          </div>
        ) : (
          <div className="error-message">
            <h2>Oops!</h2>
            <p>No gift found for this wallet address.</p>
            <button onClick={() => {
              setGiftStatus(null);
              setShowAnimation(false);
            }}>Try Again</button>
          </div>
        )}
      </div>
    </div>
  );
}

function App() {
  const projectId = '74d90fc2648b04b4e4fac2ae5fd1791d'
  const networks = [bsc]
  const metadata = {
    name: 'UNS GIFT',
    description: 'UNS GIFT',
    url: 'https://mywebsite.com',
    icons: ['https://avatars.mywebsite.com/']
  }

  createAppKit({
    adapters: [new EthersAdapter()],
    networks,
    metadata,
    projectId,
    features: {
      analytics: true
    }
  })

  return (
    <Router>
      <Routes>
        <Route path="/" element={<GiftCheck />} />
        <Route path="/admin" element={<AdminPanel />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;
